module.exports = __webpack_public_path__ + "static/img/bg2.40b49df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg2.jpg
// module id = m9TX
// module chunks = 0